import { SafePlugin } from '../local-safe-plugin';
import { patchAnnotationFloatingToolbarPluginKey } from './patch-annotation-floating-toobar-plugin-key';
import { patchFloatingToolbar } from './toolbar';
/**
 * This sets up a prosemirror plugin which patches the floating-toolbar created by the
 * annotation EditorPlugins.
 *
 * This plugin exists because when developing the Editor AI Experience, we were unable to
 * rely on changes to the editor core package being available in product.
 *
 * In future, the intention is to create a seperate EditorPlugin which is used by both
 * editor-plugin-ai and the annotation plugin to add items to a common floating toolbar
 * which is shown for range selections.
 *
 */
export function createPatchAnnotationFloatingToolbarPlugin({
  getIntl,
  rangeConfig,
  aiGlobalOptIn
}) {
  return new SafePlugin({
    key: patchAnnotationFloatingToolbarPluginKey,
    appendTransaction: (_tx, _oldState, newState) => {
      patchFloatingToolbar({
        editorState: newState,
        rangeConfig,
        getIntl,
        aiGlobalOptIn
      });
      return null;
    }
  });
}